/**
 * Shared price display helpers — avoid "$$7/mo" when values already include $.
 */

export function priceAmount(price) {
  if (price == null || price === "") return "";
  if (typeof price === "number" && Number.isFinite(price)) {
    return Number.isInteger(price) ? String(price) : price.toFixed(2);
  }
  const match = String(price).replace(/,/g, "").match(/(\d+(\.\d+)?)/);
  if (!match) return String(price).replace(/^\$+/, "").trim();
  const n = Number(match[1]);
  return Number.isInteger(n) ? String(n) : n.toFixed(2);
}

/** "$7" — never doubles the dollar sign */
export function formatDollarPrice(price) {
  const amount = priceAmount(price);
  if (!amount) return "";
  return `$${amount}`;
}

/** "$7/mo" */
export function formatMonthlyPrice(price) {
  const dollar = formatDollarPrice(price);
  if (!dollar) return "";
  return `${dollar}/mo`;
}

export function parsePriceNumber(price) {
  const amount = priceAmount(price);
  const n = Number(amount);
  return Number.isFinite(n) ? n : 0;
}
